const errorsDict = {
  'Address not geocoded.': 'Invalid location. check your zip code matches your address and city,',
  'Zip not valid for the state.': 'Invalid location. check your zip code matches your address and city,',
  INVALID_EMAIL: 'This email is invalid',
  BLOCKED_EMAIL: 'This email is blocked',
};

export const extractError = (error) => {
  if (error && error.non_field_errors) {
    return convertError(error.non_field_errors[0]);
  }

  if (error && error.detail) {
    return convertError(error.detail);
  }

  if (Array.isArray(error)) {
    return convertError(error[0]);
  }

  if (typeof error === 'object') {
    const [firstError] = Object.values(error);

    if (Array.isArray(firstError)) {
      return convertError(firstError[0]);
    }
  }

  if (!error) return '';

  return convertError(error.toString());
};

function convertError(error) {
  if (errorsDict[error] || errorsDict[error.toString()]) {
    return errorsDict[error.toString()];
  }

  return error;
}

export const getError = (error) => {
  return errorsDict[error] || error || 'Unknown Error';
};

export default { normalizeAvalaraError: getError, extractError };
